import graphql from './graphql';

const query = /* GraphQL */ `
  query getSignedUrl($key: String, $contentType: String) {
    getSignedUrl(key: $key, contentType: $contentType) {
      signedUrl
    }
  }
`;

const S3getSignedUrl = async ({ key, contentType }) =>
  graphql(query, { key, contentType }).then(({ getSignedUrl }) => getSignedUrl);

export default S3getSignedUrl;
